<template>
<div>
                <div class="px-4 pt-2 sidebar-scrollable-form">
                        <div class="client_recipient mb-4" style="white-spcae: normal; word-break: break-word;">

                          <strong class="mr-1">To:</strong>
                        <!-- <vs-input class="inputx" v-model="mail_id_added"  style="width:100%" /> -->
                        <!-- {{`${mail_id_added}`}} -->
                        <!-- {{mail_id_added.join(',')}} -->
                        <div class="mail-badge" v-for="(eachMail, index) in mail_id_added" :key="index">
                          {{ eachMail }}
                        </div>
                          </div>
                          <div class="mb-4">
                            <vs-textarea class="my-2" label="Write a Subject Line" v-model="emailSubject" />
                          </div>

                    <div class="mb-4">

                    <editor
                    api-key="dby84f0rwttg363c3yyx0t5jucrrxd2rsclfsoi76uhjy4ez"
                    output-format="text"
                    v-model="emailBody"
                    :init="{
                        height: 500,
                        menubar: true,
                        branding: false,
                        images_upload_url: image_url,
                        automatic_uploads: true,
                        images_upload_credentials:true,
                        images_upload_handler:example_image_upload_handler,
                        plugins: [
                        'autolink lists link image charmap print preview anchor',
                        'imagetools',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount',
                        'code lists fullscreen',
                        'emoticons'
                        ],
                        menu:'table',
                        toolbar:'insertfile image link |undo redo | formatselect | bold italic backcolor | \
                        table alignleft aligncenter alignright alignjustify | \
                        bullist numlist outdent indent | removeformat | help',
                    }"
                    />
                    </div>

                    <div class="email-action-btns">
                      <vs-button class="mt-4 compose-btns" @click="sendSaveEmail()" radius color="primary" type="filled" icon="send" size="large"></vs-button>
                    </div>

                </div>
 </div>
</template>

<script>
import Bell from './Bell'
import Editor from '@tinymce/tinymce-vue'
import vSelect from 'vue-select'
import { contentFileUpload} from '@/api/course-builderapi'
import Pagination from '@/components/common/pagination'

import { PermissionMiddleware } from '../../../mixins/middleware/PermissionMiddleware'

export default {
  name: 'Email',
  components: {
    Bell,
    'editor': Editor,
    vSelect,
    Pagination
  },
  props:{
    mail_id:{
      type:Array,
      required:true,
      default:() => []
    }
  },
  mixins:[PermissionMiddleware],
  data:() => ({

    query_page: {
      inbox: {
        total: '',
        limit: 10,
        has_next: false,
        current_page: 1,
        next_page_url: null,
        previous_page_url: ''
      }
    },
    user_recipient:true,
    tinyMceApi:'',

    emailSubject:'',
    emailBody:'',
    image_url: '',
    textarea:'',
    from_user_type:'1',
    selected_user_recipient:[],
    selected_client_recipient:[],
    selected_staff_recipient:[],
    selected_staff_recipient_cc:[],

    selected_user_recipient_cc:[],
    selected_client_recipient_cc:[],
    external_users:'',
    external_users_arr:[],
    external_users_cc:'',
    sendEmailToUsers:[],
    selected:[],
    log: [],
    emailSidebar: false,
    localContentValue:'',
    recipient_user_list:[],
    recipient_client_list:[],
    recipient_user_list_cc:[],
    recipient_client_list_cc:[],
    recipient_staff_list:[],
    recipient_staff_list_cc:[],


    EmailInboxData:[],
    EmailSentData:[],
    EmailDraftData:[],
    recipient_type: false,
    EmailInboxData_new_message_count:'',
    showBtn: false,
    activeEditDraftId: null,
    mail_id_added:[]

  }),
  created () {
    this.mail_id_added = [...this.mail_id]
    this.tinyMceApi = process.env.VUE_APP_TINYMCE_API

    const customer_id = localStorage.getItem('customer_id')
    this.image_url = `http://cx-lms-api-dev.track-progress.com/api/file/upload/${customer_id}`

    const role_permission = parseInt(localStorage.getItem('role_permission'))
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('CRM')
    }

  },
  methods: {
    handlePageChange (list_type, page) {
      this.selected.length = 0
      if (list_type === 'inbox') {
        this.query_page.inbox.current_page = page
        this.getInboxList()
      } else if (list_type === 'sent') {
        this.query_page.sent.current_page = page
        this.getSentList()
      } else if (list_type === 'draft') {
        this.query_page.draft.current_page = page
        this.getDraftList()
      }
    },
    preventCommaKey (event) {
      //
      const keyCode = (event.keyCode ? event.keyCode : event.which)
      if (keyCode === 44) {
        event.preventDefault()
      }
    },
    preventVSTable () {
    },
    selectedAll (e, email_type) {

      let select_data = []
      if (email_type === 'sent') {
        select_data = this.EmailSentData
      } else if (email_type === 'inbox') {
        select_data = this.EmailInboxData
      } else if (email_type === 'draft') {
        select_data = this.EmailDraftData
      }

      if (e.toElement.checked) {
        this.selected = select_data.map((id) => {
          return id.id
        })
      } else {
        this.selected = []
      }

      select_data = []
    },
    images_upload_handler (blobInfo, success, failure) {


      const xhr = new XMLHttpRequest()
      xhr.withCredentials = true
      xhr.open('POST', this.image_url)

      xhr.upload.onprogress = function (e) {
        progress(e.loaded / e.total * 100)
      }

      xhr.onload = function () {
        // let json

        if (xhr.status === 403) {
          failure(`HTTP Error: ${  xhr.status}`, { remove: true })
          return
        }

        if (xhr.status < 200 || xhr.status >= 300) {
          failure(`HTTP Error: ${  xhr.status}`)
          return
        }

        const json = JSON.parse(xhr.responseText)

        if (!json || typeof json.location !== 'string') {
          failure(`Invalid JSON: ${  xhr.responseText}`)
          return
        }

        success(json.location)
      }

      xhr.onerror = function () {
        failure(`Image upload failed due to a XHR Transport error. Code: ${  xhr.status}`)
      }

      xhr.setRequestHeader('Authorization', `Bearer ${JSON.parse(localStorage.getItem('access_token'))}`)


      const formData = new FormData()
      formData.append('files[0]', blobInfo.blob(), blobInfo.filename())


      xhr.send(formData)
    },
    example_image_upload_handler (blobInfo, success, failure, progress) {

      const formData = new FormData()
      formData.append('files[0]', blobInfo.blob())

      const data =  this.fileupload(formData)

      data.then(res => {

        const locationObject = {
          src:{
            value:{
              location:res
            }
          }
        }

        const stringify = JSON.stringify(res)
        const parse = JSON.parse(stringify)

        success(parse)
      }).catch(error => {

      })

    },

    async fileupload (payload) {
      try {
        const customer_id = localStorage.getItem('customer_id')


        const responseImage = await contentFileUpload(customer_id, payload)
        const location = responseImage.data.data.cdn + responseImage.data.data.files[0].file_path
        this.$vs.notify({
          title:'Success',
          text: 'Image Uploaded Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color:'success',
          time: 3000
        })
        return (location)
      } catch (error) {

      }
    },

    composeEmail () {
      //
      this.emailSidebar = true
      this.activeEditDraftId = null
    },
    clearComposeEmail () {
      this.emailSubject = ''
      this.emailBody = ''
      this.selected_user_recipient = []
      this.selected_client_recipient = []
      this.selected_user_recipient_cc = []
      this.selected_client_recipient_cc = []
      this.sendEmailToUsers = []
      this.external_users = ''
      this.external_users_cc = ''
      this.external_users_arr = []
      this.custom_user_recipient = false
      this.client_recipient = false
      this.custom_user_recipient_cc = false
      this.client_recipient_cc = false
      this.selected_recipient_cc = []
      this.emailSidebar = false
    },
    getSelectedRecipientObject (selected_recipient, to_user_type, is_root_user) {
      for (let i = 0; i < selected_recipient.length; i++) {
        this.sendEmailToUsers.push(
          {
            'to_user_id': selected_recipient[i],
            to_user_type,
            is_root_user
          })
      }
    },
    getCustomEmailObject (external_user, is_root_user) {
      external_user = external_user.split(',')
      for (let i = 0; i < external_user.length; i++) {
        if (external_user[i].trim() !== '') {
          this.external_users_arr.push(
            {
              'email': external_user[i].trim(),
              is_root_user
            })
        }

      }
    },
    async sendSaveEmail () {

      const mail = []
      mail.push(this.mail_id_added, this.emailSubject, this.emailBody)
      this.$emit('mail_body', mail)


    },
    async saveAsDraft () {
      for (let i = 0; i < this.selected_recipient.length; i++) {
        this.sendEmailToUsers.push(
          {
            'to_user_id': this.selected_recipient[i],
            'to_user_type':1,
            'is_root_user':true
          })
      }

      for (let i = 0; i < this.selected_recipient_cc.length; i++) {
        this.sendEmailToUsers.push(
          {
            'to_user_id': this.selected_recipient_cc[i],
            'to_user_type':1,
            'is_root_user':false
          })
      }


      try {
        //this.$vs.loading()
        const customer_id = localStorage.getItem('customer_id')
        // eslint-disable-next-line no-unused-vars
        //  const data = await sendSaveEmail(customer_id, emailPayload)
        //
        this.clearComposeEmail()
        this.getDraftList()

        this.$vs.notify({
          title: 'Success',
          text: 'Email saved as draft',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
      } catch (error) {

        let errorText = ''
        if (error.data.errors.body) {
          errorText = 'Body is required'
        } else if (error.data.errors.to_users) {
          errorText = 'To users is required'
        } else if (error.data.errors.subject) {
          errorText = 'Subject is required'
        }

        this.$vs.notify({
          title: 'Error',
          text: errorText,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 3000
        })
      } finally {
        //this.$vs.loading.close()
      }
    },
    openEmailDetailsPage (details_page_type, event) {
      //setTimeout(function(){
      //
      this.selected = []
      const email_id = event.id
      this.$router.push({
        name: 'Email_Details',
        params: { email_id, details_page_type }
      })
      //})
    }

  },

  beforeRouteLeave (to, from, next) {

    this.emailSidebar = false
    setTimeout(() => {
      next()
    }, 0)


  }
}
</script>

<style>
  .vuesax-app-is-ltr .vs-sidebar.vs-sidebar-position-right {
  z-index: 1000;
  }
  .unread {
    background-color: #fff5ec;
    font-weight: 500;
  }
  .new {
    background-color: transparent !important;
    font-weight: 500;
  }
  .email-table tr {
    box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.2);
    position: relative;
  }
  .email-table tr:hover .delete-btn {
    display: block;
    top: 0;
  }
  .email-card {
    position: relative;
  }
  .compose-btn,
  .delete-all-btn {
      position: absolute;
      right: 20px;
      top: 10px;
      /* background: #FF9F43 !important;
      box-shadow: 0 8px 25px -8px rgba(255, 159, 67, 1) !important; */
  }
  .delete-all-btn {
      right: 100px;
  }
  .delete-btn {
    display: none;
    position: absolute;
    /* top: 10px; */
    right: 30px;
    padding: 0 10px;
  }
  .delete-btn:hover {
    background: #e9eaea;
    border-radius: 50%;
  }
  .delete-btn .feather-icon {
    margin: 8px 0;
  }
  .delete-btn svg {
    width: 18px;
    color: #727373;
  }
  .email-sidebar .vs-sidebar {
    max-width: 400px;
    margin-top: 107px;
   }
   .email-sidebar .sidebar-scrollable-form {
    height: calc(100% - 175px);
    overflow-y: auto;
    overflow-x: hidden;
   }
   .email-form input,
   .email-form input:focus {
       border: none !important;
       box-shadow: none;
   }
   .sub-line {
       border: none !important;
       height: 40px;
   }
  .email-action-btns{
    text-align: right;
  }
   .compose-btns{
    display: inline;
    margin-right: 15px;
   }
   .email-cc{
     margin-top: 15px;
   }
   .selectCheckBox{
     width:5px;
   }
   .mail-badge {
    display: inline-flex;
    align-items: center;
    background-color: rgba(var(--vs-primary), 1);
    color: #fff;
    margin: 2px;
    padding: 2px 10px;
    border-radius: 10rem;
   }

   @media (max-width: 360px) {
       .email-sidebar .vs-sidebar {
            max-width: 100%;
        }
   }
</style>